import * as React from "react";
import { cn } from "../../Lib/Cn";

const Textarea = React.forwardRef(
  ({ className, allowResize = false, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "sahi-input border-input placeholder:text-muted-foreground flex field-sizing-content min-h-16 w-full rounded-md bg-primary-foreground px-3 py-2 text-primary shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50",
          "md:text-sm selection:bg-primary selection:text-primary-foreground",
          !allowResize && "resize-none", // conditionally disable resize
          className
        )}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
